import { render, staticRenderFns } from "./payItems.vue?vue&type=template&id=7c5a28e8&scoped=true"
import script from "./payItems.vue?vue&type=script&lang=js"
export * from "./payItems.vue?vue&type=script&lang=js"
import style0 from "./payItems.vue?vue&type=style&index=0&id=7c5a28e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a28e8",
  null
  
)

export default component.exports